import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { CoverageCard } from "../atoms/CoverageCard";
import { colors } from "../../../ui/colors";
import ICoverageListProps from "../../interfaces/ICoverageLIstProps";

export const CoverageList: React.FC<ICoverageListProps> = ({
  coverageAreas,
  selectedId,
  onSelect,
  isSearchActive,
  onRadiusChange,
  onDelete,
  onUpdate,
  onColorChange,
  onOpenEditMode,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",

        flexDirection: isMobile ? "row" : "column",
        gap: 1.5,
        width: "100%",
        overflowX: isMobile ? "auto" : "hidden",
        overflowY: isMobile ? "hidden" : "auto",
        scrollSnapType: isMobile ? "x mandatory" : "none",
        scrollBehavior: "smooth",
        pb: isMobile ? 2 : 0,
        "&::-webkit-scrollbar": { display: "none" },
        msOverflowStyle: "none",
        scrollbarWidth: "none",
      }}
    >
      {coverageAreas.map((area) => (
        <Box
          key={area.id}
          sx={{
            minWidth: isMobile ? "85%" : "100%",
            scrollSnapAlign: "center",
          }}
        >
          <CoverageCard
            area={area}
            isSelected={area.id === selectedId}
            onSelect={() => onSelect(area.id)}
            colorPoint={area.color}
            onRadiusChange={(valueInMeters) => onRadiusChange(area.id, valueInMeters)}
            onDelete={() => onDelete(Number(area.id))}
            onColorChange={onColorChange}
            onOpenEditMode={onOpenEditMode}
            onUpdate={(updatedArea) => onUpdate(updatedArea)}
          />
        </Box>
      ))}

      {coverageAreas.length === 0 && (
        <Box
          sx={{
            width: "100%",
            py: 4,
            textAlign: "center",
            border: 2,
            borderColor: colors.gray[100],
            borderStyle: "dashed",
            borderRadius: "12px",
            bgcolor: "var(--fx-surface-sunken, #F8FAFC)",
          }}
        >
          {isSearchActive ? "No results for this search" : "You haven't created any areas yet"}
        </Box>
      )}
    </Box>
  );
};

export default CoverageList;
